import axios from '../common/js/axios'
import { host } from '../common/js/config'

/*直播*/
export function getLiveBackInfo(data){
	const url = `${host}/app/showliveinfo/`
	return axios({
		url: url+data
	})
}

//判断直播是否可以观看
export function allowWatch(data){
	const url = `${host}/app/liveCourse/isAllowWatch`
	return axios({
		url: url+data
	})
}

export function getToken2(data){
	const url = `${host}/app/course/getSignAndGetChatToken`
	return axios({
		url: url,
		params: data
	})
}

//参团列表
export function getpintuanList(data){
	const url = `${host}/app/course/spellgroup`
	return axios({
		url: url,
		params: data
	})
}


// WEBPACK FOOTER //
// ./src/api/watch.js